
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DialogBanner from "../app/DialogBanner.vue";
import FormService from "@/services/FormService";
import User, { userRole } from "@/domain/user/User";
import { VuetifyForm } from "@/plugins/vuetify";
import RemoteServices from "@/services/RemoteServices";
import InternationalizationService from "@/services/InternationalizationService";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
@Component({
  components: { ConfirmationDialog, DialogBanner }
})
export default class UserDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: () => new User() })
  user!: User;

  userCopy: User = User.copy(this.user);

  formValid = false;

  requiredString = [FormService.requiredStringRule];

  emailRule = [FormService.emailFormatRule, FormService.requiredStringRule];

  loading = false;

  get hasChanges() {
    return User.haveDifferences(this.user, this.userCopy);
  }

  get isAdmin() {
    return this.user.role === "ADMIN";
  }

  get isNewUser() {
    return this.user.userId == null;
  }

  get roleList() {
    return User.roles.filter(
      (role: userRole) => !this.isNewUser || role.allowCreate
    );
  }

  get countryCodeList() {
    return InternationalizationService.selectCountryCodes;
  }

  get restaurantList() {
    return this.$store.getters.getRestaurantList;
  }

  get dialog() {
    return this.value;
  }

  set dialog(newVal: boolean) {
    this.resetUser();
    this.$emit("input", newVal);
  }

  get form() {
    return this.$refs.userForm as VuetifyForm;
  }

  get title() {
    if (this.isNewUser) return this.$t("user.create.message");
    return this.$t("user.edit.message");
  }

  get confirmationDialog() {
    return this.$refs.confirmationDialog as ConfirmationDialog;
  }

  @Watch("user")
  resetUser() {
    this.userCopy = User.copy(this.user);
  }

  closeAndResetDialog() {
    this.dialog = false;
  }


  async createUser() {
    if (this.formValid) {
      this.loading = true;
      try {
        const newUser = await RemoteServices.createUser(this.userCopy);
        this.emitNewUser(newUser);
        await this.$store.dispatch("success", this.$t("user.create.success"));
        this.closeAndResetDialog();
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.loading = false;
    }
  }

  async updateUserProperties() {
    if (this.formValid) {
      this.loading = true;
      try {
        const updatedUser = await RemoteServices.updateUserProperties(
          this.userCopy
        );
        this.updateUserOBJ(updatedUser);
        await this.$store.dispatch("success", this.$t("user.edit.success"));
        this.closeAndResetDialog();
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.loading = false;
    }
  }

  async deleteUser() {
    if (
      await this.confirmationDialog.open(
        this.$tc("user.delete.message"),
        this.$t("delete.confirmation") +
          "\n" +
          this.user.name +
          "\n" +
          this.$t("delete.warning")
      )
    ) {
      this.loading = true;
      try {
        await RemoteServices.deleteUser(this.user);
        this.emitDeleteUser();
        await this.$store.dispatch("success", this.$t("user.delete.success"));
        this.closeAndResetDialog();
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.loading = false;
    }
  }

  updateUserOBJ(newUser: User) {
    User.updateUser(this.user, newUser);
  }

  emitDeleteUser() {
    this.$emit("delete-user", this.user);
  }

  emitNewUser(newUser: User) {
    this.$emit("new-user", newUser);
  }
}
